var intervalstart = "";
async function OnloadCheckLocalStorage() {
  var onclickVar = 0; //check if load
  var getStorage = jQuery.parseJSON((localStorage.getItem("customstorage")));
  console.log('varsha1: ', getStorage);

  if (getStorage && Object.keys(getStorage).length > 0) {
    for (val in getStorage) {
      // console.log('varsha2: ',val)
      if (val == "discount") {
        console.log('varsha3: ', val)
        var discountPriceRule = getStorage[val].discountPriceRule;
        var discountcodeid = getStorage[val].discountcodeid;
        var cartid = getStorage[val].cartid;
        await getAppliedDiscountData(discountPriceRule, discountcodeid, onclickVar, cartid); //apply discount on load
        console.log("disocunt finish++");
      } else if (val == "giftcard") {
        console.log('varsha4: ', val)
        var giftCardPrice = getStorage[val].giftCardPrice;
        var giftCard = getStorage[val].giftCard;
        var cartid = getStorage[val].cartid;
        var newDiscount = await getAppliedGiftCardDataOnLoad(giftCardPrice, giftCard, cartid); //get and match giftcard with database and 
        console.log("gift card finish++");
      }

    }
  }
}
jQuery(document).ready(function() {
  // Only Work If It Is A Checkout Page

  if (window.location.href.indexOf("/orders") > -1) {
    console.log('nothing to show');
    jQuery('.gift-coupan').hide();

  } else {
    if (window.location.href.indexOf("/checkouts") > -1) {
      jQuery('.total-line__name .reduction-code').css('background:yellow;font-weight:bold;padding:6px;');
      if (window.location.href.indexOf("/thank_you") > -1) {
        console.log('nothing to show');
        jQuery('.gift-coupan').hide();
      }

    }
  }
  if (window.location.href.indexOf("/cart") > -1) {

    OnloadCheckLocalStorage()


  }
  //cart submission
  jQuery('.cart__submit').on('click', function(e) {

    //var discountcodeval = jQuery(".discountcodeval").val();

    e.preventDefault();
    console.log('hello click+++');
    $('#loader').show();
    jQuery.getJSON('/cart.js', function(cart) {
      gotoCheckout(cart.token);
      console.log("newDiscount++last");
    });




  });

  //discount coupon apply function
  jQuery('#discountapply').on('click', function(e) {
    console.log('hello click+++');
    var discountcode = jQuery(".discountcodeval").val();
    var discountcodeval = discountcode.trim()
    $('#discountapply').prop('disabled', true);
    jQuery(".discount-response").html('');
    jQuery(".discount-response_success").html('');
    $('.loaderonclick').show();
    var discountApplied = $('a').hasClass('discountremove');

    if (discountcodeval == "") {
       $('.loaderonclick').hide();
      $('#discountapply').prop('disabled', false);
      jQuery(".discount-response").html('<span style="color:red">Please enter discount code.</span>');
      return false;
    } else if (discountApplied) {
      $('.loaderonclick').hide();
      $('#discountapply').prop('disabled', false);
      jQuery(".discount-response").html('<span style="color:red">discount coupon is already active. Remove that to apply another</span>');
      return false;

    }
    var url = window.location.origin;
    e.preventDefault();
    var app_url = 'https://lovelesscafe.localgiftcards.net/web/index.php/smarttransaction';
    jQuery.ajax({
      type: 'post',
      dataType: "json",
      url: app_url + '/validatediscount',
      crossDomain: true,
      data: {
        "discount": discountcodeval,
        "site_url": url
      },
      success: function(res) {
        console.log(res);

        var dataval = jQuery.parseHTML(res.msg);

        //var fullurl = dataval[1].href;
        if (res.msg == "") {
          $('.loaderonclick').hide();
          $('#discountapply').prop('disabled', false);
          jQuery(".discount-response").html('<span style="color:red">Discount has been expired.</span>');
          return false;
        }
        console.log(dataval.length);
        console.log(dataval);
        var onclickVar = 1; //check if load
        //if (typeof dataval[1].href !== 'undefined') {
        if (dataval.length > 2) {
          var str = dataval[1].href;
          var arr = str.split('price_rules/');


          if (typeof arr[1] !== 'undefined') {
            var pricerule_id = arr[1].split('/');
            console.log(pricerule_id);
            var priceruleIds = pricerule_id[0];
            var disocuntIdssplit = pricerule_id[2].split('.');
            var disocuntIds = disocuntIdssplit[0];

            getAppliedDiscountData(priceruleIds, disocuntIds, onclickVar);

          }

          console.log(arr);
          //console.log(priceruleId);

        } else {
          $('.loaderonclick').hide();
          $('#discountapply').prop('disabled', false);
          jQuery('.coupon_label_display').html('');
          removeDiscountStorage(); //delete disocunt local storage

          // }
          jQuery(".discount-response").html('<span style="color:red">Invalid discount code.</span>');
          return false;
        }
      }
    });


  });



  jQuery('#iamclick').on('click', function(e) {
    console.log('hello click');


    var cardnumber = jQuery(".cardnumber").val();
    var giftCardApplied = $('a').hasClass('giftcardremove');
    var url = window.location.origin;
    $('#iamclick').prop('disabled', true);
    e.preventDefault();
    jQuery(".cardnumber-response").html('');
    jQuery(".cardnumber-response").text("Processing, Please wait!");
    jQuery(".cardnumber-response_success").css('display', 'none');
    // var checkout_total_val = $(".cart__subtotal .saw-cart-original-total").text().replace('$', '').replace(/\s+/g, " ");
    var checkout_total_val = $(".cart-subtotal .money").text().replace('$', '').replace('Your Cart Subtotal', '').replace(/\s+/g, " ");
    var checkout_total = checkout_total_val.replace(/,/g, '');
    if (cardnumber == "") {
      $('#iamclick').prop('disabled', false);
      jQuery(".cardnumber-response").html('');
      jQuery(".cardnumber-response").html('<span style="color:red">Please enter Gift card.</span>');
      return false;
    } else if (giftCardApplied) {
      $('#iamclick').prop('disabled', false);
      jQuery(".cardnumber-response").html('');
      jQuery(".cardnumber-response").html('<span style="color:red">Gift card is already active. Remove that to apply another</span>');
      return false;

    } else if (checkout_total < 1) {
      $('#iamclick').prop('disabled', false);
      jQuery(".cardnumber-response").html('<span style="color:red">Cart amount already zero</span>');
      return false;
    }


    jQuery.getJSON('/cart.js', function(cart) {
      var app_url = 'https://lovelesscafe.localgiftcards.net/web/index.php/smarttransaction';
      // get the order total


      //var checkout_total = getTotalAmt();
      $(".saw-cart-original-total-val").text('$' + checkout_total);

      var getAppliedCoupon = getAppliedDiscount();
      const extractedToken = cart.token.split('?')[0];
      console.log('total ' + checkout_total);
      console.log(getAppliedCoupon);
      jQuery.ajax({
        type: 'post',
        dataType: "json",
        url: app_url + '/smarttransactionprocessing',
        crossDomain: true,
        data: {
          "cardnumber": cardnumber,
          "site_url": url,
          "cartAmount": checkout_total,
          "cart_id": extractedToken,
          "discountAdded": getAppliedCoupon
        },
        success: function(res) {
          //var result = JSON.parse(res);
          console.log('consoledata: ' + res);
          jQuery(".cardnumber-response").html('');
          if (res.status == 'success_insufficient') {
            jQuery(".cardnumber-response_success").text(res.info);
            jQuery(".cardnumber-response_success").addClass('insufficient');
            jQuery(".cardnumber-response_success").css('display', 'block');
            jQuery(".cardnumber-response_success").css('background', 'yellow');

            jQuery('#sts_offer_discount').attr('value', res.code); // new line added
            
            jQuery('.giftcard_label_display').show();
            var checkCodeType = 0; //for disocunt
            jQuery('.giftcard_label_display').html(
              '<div class="d-flex">' +
              '<div class="mr-2 giftcard_applied cssclass">GiftCard Applied</div>' +
              '<div class="total_discount cssclassother">$<span>' + res.price + '</span></div>' +
              '<div class="mr-2 remove-code cssclassother"><a href="javascript:void(0);" class="giftcardremove" onclick="removeDiscountCode(' + checkCodeType + ',\'' + res.price + '\',\'' + cart.token + '\',\'' + res.code + '\')">Remove</a></div>' +
              '</div>'

            );
            var pendingcartprice = parseFloat(checkout_total) - parseFloat(res.price);
            $('.saw-cart-original-total').text('$' + parseFloat(pendingcartprice).toFixed(2));
            setgiftCardStorage(res.price, res.code, cart.token);

            //jQuery('.offer_discount').val(res.code);
            //             setTimeout(function () {
            //               jQuery('#coupons_stacker_input').val(res.code);
            //               jQuery('#coupons_stacker_add_button').trigger('click');
            //             }, 1000);

            //             localStorage.getItem("giftCardPrice",res.price);
            //             localStorage.setItem("giftCard", res.code);


            jQuery('[data-trekkie-id="apply_discount_button"]').removeAttr("disabled");
            jQuery('button.field__input-btn.btn').removeClass("btn--disabled");
            // jQuery("input#checkout_reduction_code").parent().parent().find('button').addClass('btngiftsubmit');  
            // jQuery("input#checkout_reduction_code").val(res.code);
            $('#iamclick').prop('disabled', false);
          } else if (res.status == 'success') {
            jQuery(".cardnumber-response_success").css('display', 'block');
            jQuery(".cardnumber-response_success").text(res.info);
            
            jQuery('#sts_offer_discount').attr('value', res.code); // new line added
            
            var checkCodeType = 0; //for disocunt
            jQuery('.giftcard_label_display').show();
            jQuery('.giftcard_label_display').html(
              '<div class="d-flex">' +
              '<div class="mr-2 giftcard_applied cssclass">GiftCard Applied</div>' +
              '<div class="total_discount cssclassother">$<span>' + res.price + '</span></div>' +
              '<div class="mr-2 remove-code cssclassother"><a href="javascript:void(0);" class="giftcardremove" onclick="removeDiscountCode(' + checkCodeType + ',\'' + res.price + '\',\'' + cart.token + '\',\'' + res.code + '\')">Remove</a></div>' +
              '</div>'

            );

            var pendingcartprice = parseFloat(checkout_total) - parseFloat(res.price);
            $('.saw-cart-original-total').text('$' + parseFloat(pendingcartprice).toFixed(2));
            setgiftCardStorage(res.price, res.code, cart.token);
            //jQuery('.offer_discount').val(res.code);

            //             setTimeout(function () {
            //               jQuery('#coupons_stacker_input').val(res.code);
            //               jQuery('#coupons_stacker_add_button').trigger('click');
            //             }, 1000);


            //             localStorage.getItem("giftCardPrice",res.price);
            //             localStorage.setItem("giftCard", res.code);

            jQuery('[data-trekkie-id="apply_discount_button"]').removeAttr("disabled");
            jQuery('button.field__input-btn.btn').removeClass("btn--disabled");
            // jQuery("input#checkout_reduction_code").parent().parent().find('button').addClass('btngiftsubmit');  
            // jQuery("input#checkout_reduction_code").val(res.code);
            $('#iamclick').prop('disabled', false);


          } else {

            $('#iamclick').prop('disabled', false);
            if (res.mes == undefined) {
              jQuery(".cardnumber-response").html('<span style="color:red">Please try later.</span>');
            } else {
              jQuery(".cardnumber-response").html('<span style="color:red">' + res.mes + '</span>');
            }

          }
        },
        error: function(err) {
          console.log('error: ' + err);


          $('#iamclick').prop('disabled', false);
          if (err.mes == undefined) {
            jQuery(".cardnumber-response").html('<span style="color:red">Please try later.</span>');
          } else {
            jQuery(".cardnumber-response").html('<span style="color:red">' + err.mes + '</span>');
          }
        }
      });
    });
  });

});
//get disocunt full data
async function getAppliedDiscountData(priceruleid, disocuntIds, onclickVar) {
  console.log('varsha 4:');
  jQuery(".discount-response").html('');
  jQuery(".discount-response_success").html('');
  jQuery('.coupon_label_display').html('');
  var url = window.location.origin;
  var app_url = 'https://lovelesscafe.localgiftcards.net/web/index.php/smarttransaction';
  var checkout_total_val = $(".cart__subtotal .saw-cart-original-total").text().replace('$', '').replace(/\s+/g, " ");
  var carttotalprice = checkout_total_val.replace(/,/g, '');
  var loggedCustomIds = $('#customerids').val();
  var cart = await jQuery.getJSON('/cart.js'); //, function (cart) {
  var currentCartId = cart.token;
  console.log('varsha 5:');


  console.log(cart);
  if (carttotalprice < 1) {
    $('.loaderonclick').hide();
    $('#discountapply').prop('disabled', false);
    jQuery(".discount-response").html('<span style="color:red">Cart amount already zero.</span>');
    return false;
  }
  if (onclickVar == 1) { //click

    var load = 1;


  } else {
    var load = 0;
  }
  // if user already added the giftcard and delete local strorage if cart id not same
  var checkGiftcardAdded = false;
  var getStorage = jQuery.parseJSON((localStorage.getItem("customstorage")));
  if (getStorage && Object.keys(getStorage).length > 0) {
    var keysarray = Object.keys(getStorage);
    //.log('keysarray',keysarray);
    console.log('keysarray',keysarray[0]);
    
    // currentCartId="SddsadsadsadsdsdD";
    if (jQuery.inArray("discount", keysarray) !== -1) {
      if (currentCartId != getStorage['discount'].cartid) {
        console.log('remove+++')
        $('.loaderonclick').hide();
        $('#discountapply').prop('disabled', false);
        
        removeDiscountStorage();
        return false;
      }
    }
    if (keysarray[0] == "giftcard") {
      checkGiftcardAdded = true;
    }
  }

  var res = await jQuery.ajax({
    type: 'post',
    dataType: "json",
    url: app_url + '/applieddiscountdata',
    crossDomain: true,
    data: {
      "pricerule": priceruleid,
      'discount_code_id': disocuntIds,
      "site_url": url,
      "cart_id": cart.token,
      "carttotalprice": carttotalprice,
      "carttotalProductQty": cart.item_count,
      'cart': cart.items,
      'loggedCustomId': loggedCustomIds,
      'userEvent': load,
      "cartOverallPrice": cart.total_price,
      "cartOverallQuantity": cart.item_count,
      "issetGiftCard": checkGiftcardAdded
    },
  });
  //success: function (res) {
  console.log('consoledata: ' + res);
  var data = res;
  console.log('varsha 6:');
  if (data.value != 'Invalid' && data.value != 'Invalid Coupon') {

    if (data.discountAmount != "" && data.discountCode != "" && data.priceRule != "") {
		
      jQuery('.coupon_label_display').show();
     // var d = 23;
      var checkCodeType = 1; //for disocunt
      var fixedAmt =  data.discountAmount.toFixed(2);
		console.log(data.discountAmount.toFixed(2))
      jQuery('.coupon_label_display').html(
        '<div class="d-flex">' +
        '<div class="mr-2 discount_applied cssclass">Discount Applied</div>' +
        '<div class="total_discount cssclassother">$<span>' + fixedAmt + '</span></div>' +
        '<div class="mr-2 remove-code cssclassother"><a href="javascript:void(0);" class="discountremove" onclick="removeDiscountCode(' + checkCodeType + ')">Remove</a></div>' +
        '</div>'

      );
      await setDiscountStorage(data.discountCode, data.priceRule, data.discountAmount, data.discountcodeid, cart.token);


      var pendingcartprice = await parseFloat(data.cartTotalPrice) - parseFloat(fixedAmt);
      $('.saw-cart-original-total').text('$' + parseFloat(pendingcartprice).toFixed(2));
      $('.loaderonclick').hide();
      $('#discountapply').prop('disabled', false);
      console.log('varsha 7:');
      if (onclickVar == 1) {

        $('.discount-response_success').html('<span style="color:black">Discount applied successfully</span>');

      } //jQuery('.discount_name').text("Discount (" + coupon_code + ")");
      //console.log(amount_deduction); 
    }



  } else {
    $('#discountapply').prop('disabled', false);
    $('.loaderonclick').hide();
    removeDiscountStorage(); //delete disocunt local storage;

    if (onclickVar == 1) {
      console.log(data.res);
      jQuery(".discount-response").html('<span style="color:red" >' + data.msg + '</span>');

    }

    return false;
  }



  // }

  // });
}

function removeDiscountCode(checkCodeType, giftCardPrice, cartid, giftCard) {
  console.log(checkCodeType);
  if (checkCodeType == 1) { //checkCodeType 1 for disocunt
    removeDiscountStorage(); //delete discount storage
    jQuery('.coupon_label_display').html('');
    window.location.reload();

  } else if (checkCodeType == 0) { //checkCodeType 0 for giftcard
    var manualclick = 1;
    removeGiftCardStorageAndCoupon(giftCardPrice, cartid, giftCard, manualclick); //remove discount and from database and refunded

  }
}

function getTotalAmt() {
  var temp = $('#coupons_stacker #stack-discounts-subtotal-value:not(strike)').text();
  var res = temp.split("$");
  var checkout_total_val = $(".cart__subtotal .saw-cart-original-total").text().replace('$', '').replace(/\s+/g, " ");

  if (typeof res[2] === 'undefined') {
    var val = res[1].replace(/,/g, '');
    console.log('discount applied', val);
  } else if (typeof res[1] === 'undefined') {
    var val = checkout_total_val.replace(/,/g, '');
    console.log('subtotal', val);
  } else {
    var val = res[2].replace(/,/g, '');
    console.log('discount not applied', val);
  }
  return val;
}

function getAppliedDiscount() {
  var couponArr = [];
  var i = 0;
  //var checCouponAdded = $('#coupons_stacker .coupons_stacker__tag').length;
  var checCouponAdded = $('#coupons_stacker .stack-discounts-tag').length;
  if (checCouponAdded > 0) {
    $('#coupons_stacker .stack-discounts-tag').each(function() {
      var discounts = $(this).attr("data-value");
      console.log('discounts', discounts);
      //couponArr[] =discounts;
      couponArr.push(discounts);
      i++;
    });
  }

  return couponArr;
}



function removeDiscountStorage() { // delete disocunt
  var getStorage = jQuery.parseJSON((localStorage.getItem("customstorage")));
  if (getStorage && Object.keys(getStorage).length > 0) {
    delete getStorage['discount'];
    localStorage.setItem("customstorage", JSON.stringify(getStorage));
  }



}

function removeGiftCardStorage() { //delete giftcard
  var getStorage = jQuery.parseJSON((localStorage.getItem("customstorage")));

  if (getStorage && Object.keys(getStorage).length > 0) {
    delete getStorage['giftcard'];
    localStorage.setItem("customstorage", JSON.stringify(getStorage));

  }

}
async function removeGiftCardStorageAndCoupon(giftCardPrice, cartid, giftCard, manualclick) {
  console.log('varsha 11')
  // jQuery('.giftcard_label_display').html('');
  var url = window.location.origin;
  var cart = await jQuery.getJSON('/cart.js') //, function (cart) {
  console.log('varsha 12')
  var app_url = 'https://lovelesscafe.localgiftcards.net/web/index.php/smarttransaction';

  var res = await jQuery.ajax({
    type: 'post',
    dataType: "json",
    url: app_url + '/removegiftcardstorageandcoupon', //if strorage set then this working
    crossDomain: true,
    data: {
      "site_url": url,
      "giftCardPrice": giftCardPrice,
      "giftCard": giftCard,
      "cartid": cartid
    }
  })
  console.log('varsha 13')
  if (res.status == "success" || res.status == "error") {
    console.log('varsha 14')
    removeGiftCardStorage();
    if (manualclick == 1) {
      jQuery('.giftcard_label_display').html('');
      window.location.reload();
    }

  }



}

function setgiftCardStorage(giftCardPrice, giftCard, cartid) {
  var localstorageArray = [];
  var getStorage = jQuery.parseJSON((localStorage.getItem("customstorage")));
  if (getStorage && Object.keys(getStorage).length > 0) {
    let newObj = Object.assign(getStorage, {
      'giftcard': {
        'giftCardPrice': giftCardPrice,
        'giftCard': giftCard,
        'cartid': cartid
      }
    });
    localStorage.setItem("customstorage", JSON.stringify(getStorage));
  } else {
    localstorageArray['customstorage'] = {
      'giftcard': {
        'giftCardPrice': giftCardPrice,
        'giftCard': giftCard,
        'cartid': cartid
      }
    };
    localStorage.setItem("customstorage", JSON.stringify(localstorageArray['customstorage']));
  }



}
async function setDiscountStorage(discountCode, priceRule, discountAmount, discountcodeid, cartid) {
  console.log('varsha :77')
  var localstorageArray = [];
  var discountAmountt = discountAmount.toFixed(2);
  var getStorage = jQuery.parseJSON((localStorage.getItem("customstorage")));
  if (getStorage && Object.keys(getStorage).length > 0) {
    let newObj = Object.assign(getStorage, {
      'discount': {
        'discountName': discountCode,
        'discountPriceRule': priceRule,
        'discountAmount': discountAmountt,
        'discountcodeid': discountcodeid,
        'cartid': cartid
      }
    });
    localStorage.setItem("customstorage", JSON.stringify(getStorage));
  } else {
    localstorageArray['customstorage'] = {
      'discount': {
        'discountName': discountCode,
        'discountPriceRule': priceRule,
        'discountAmount': discountAmountt,
        'discountcodeid': discountcodeid,
        'cartid': cartid
      }
    };
    localStorage.setItem("customstorage", JSON.stringify(localstorageArray['customstorage']));
  }




}


//onload
async function getAppliedGiftCardDataOnLoad(giftCardPrice, giftCard, cartid) {
  console.log('varsha 5:');
  console.log(giftCardPrice, giftCard, cartid);
  jQuery('.giftcard_label_display').html('');
  var url = window.location.origin;
  var cart = await jQuery.getJSON('/cart.js'); //, function (cart) {
  var currentCartId = cart.token;
  console.log('varsha 6:');
  //local strorage cart id not match with current
  var getStorage = jQuery.parseJSON((localStorage.getItem("customstorage")));
  if (getStorage && Object.keys(getStorage).length > 0) {
    var keysarray = Object.keys(getStorage);
    // currentCartId="SddsadsadsadsdsdD";
    if (jQuery.inArray("giftcard", keysarray) !== -1) {
      if (currentCartId != getStorage['giftcard'].cartid) {
        console.log('remove giftcard+++')
        removeGiftCardStorage();
        return false;
      }
    }
  }
  var app_url = 'https://lovelesscafe.localgiftcards.net/web/index.php/smarttransaction';
  var checkout_total_val = $(".cart__subtotal .saw-cart-original-total").text().replace('$', '').replace(/\s+/g, " ");
  var checkout_total = checkout_total_val.replace(/,/g, '');
  $(".saw-cart-original-total-val").text('$' + checkout_total);
  var giftcardonloadstorageAjax = await jQuery.ajax({
    type: 'post',
    dataType: "json",
    url: app_url + '/giftcardonloadstorage', //if strorage set then this working
    crossDomain: true,
    data: {
      "site_url": url,
      "cartAmount": checkout_total,
      "giftCardPrice": giftCardPrice,
      "giftCard": giftCard,
      "cartid": cartid
    }
  })
  //           success:  function (res) {
  console.log('varsha 7:', giftcardonloadstorageAjax);
  if (giftcardonloadstorageAjax.status == "success") {
    var checkCodeType = 0;
    jQuery('.giftcard_label_display').show();
    jQuery('.giftcard_label_display').html(
      '<div class="d-flex">' +
      '<div class="mr-2 giftcard_applied cssclass">GiftCard Applied</div>' +
      '<div class="total_discount cssclassother">$<span>' + giftCardPrice + '</span></div>' +
      '<div class="mr-2 remove-code cssclassother"><a href="javascript:void(0);" class="giftcardremove" onclick="removeDiscountCode(' + checkCodeType + ',\'' + giftCardPrice + '\',\'' + cartid + '\',\'' + giftCard + '\')">Remove</a></div>' +
      '</div>'

    );
    var pendingcartprice = parseFloat(checkout_total) - parseFloat(giftCardPrice);
    $('.saw-cart-original-total').text('$' + parseFloat(pendingcartprice).toFixed(2));

  } else if (giftcardonloadstorageAjax.status == "error") {
    var manualclick = 0;
    await removeGiftCardStorageAndCoupon(giftCardPrice, cartid, giftCard, manualclick);
  }

  console.log('varsha 8:');
  //     });
  console.log('varsha 9:');



}
async function CreateNewDiscount(discountAmount, giftCardAmount, cartid, giftCardDiscount, discountName) {
  console.log("newDiscount++5");
  var url = window.location.origin;
  var cartproductId = $('#productidss').val();
  var app_url = 'https://lovelesscafe.localgiftcards.net/web/index.php/smarttransaction';
  var createNewDiscount = await jQuery.ajax({
    type: 'post',
    dataType: "json",
    url: app_url + '/createnewdiscount', //if strorage set then this working
    crossDomain: true,
    data: {
      "discountAmount": discountAmount,
      "giftCardAmount": giftCardAmount,
      "giftCardDiscount": giftCardDiscount,
      "discountName": discountName,
      "cartid": cartid,
      "site_url": url,
      "cartproductId": cartproductId
    }
  })
  console.log("newDiscount++6");
  if (createNewDiscount.status == "success" || createNewDiscount.status == "error") {
    console.log("newDiscount++7");
    var newDiscount = await createNewDiscount.newDiscount;
    return newDiscount;

  }

}
//custom disocunt entry exist but discount only one left
async function singleDiscount(cartid) {
  console.log('ajax', cartid);
  var url = window.location.origin;
  var app_url = 'https://lovelesscafe.localgiftcards.net/web/index.php/smarttransaction';
  var deleteDiscountEntry = await jQuery.ajax({
    type: 'post',
    dataType: "json",
    url: app_url + '/deletecustomdiscount',
    crossDomain: true,
    data: {
      "cartid": cartid,
      "site_url": url
    }
  })
  console.log('ajax res', deleteDiscountEntry);
  console.log('ajax done');
  return true;
}
async function gotoCheckout(currentCartId) {
  console.log("newDiscount++1");
  var url = window.location.origin;
  var discountcode = "";
  var getStorage = jQuery.parseJSON((localStorage.getItem("customstorage")));
  console.log("newDiscount++2", getStorage);
  if (getStorage && Object.keys(getStorage).length > 0) {

    console.log("newDiscount++3", currentCartId);
    var keysarray = Object.keys(getStorage);
    if (Object.keys(getStorage).length == 2) {
      //discount create
      if (jQuery.inArray("discount", keysarray) !== -1 && jQuery.inArray("giftcard", keysarray) !== -1) {
        var discountAmount = parseFloat(getStorage['discount'].discountAmount);
        var giftCardAmount = parseFloat(getStorage['giftcard'].giftCardPrice);
        var giftCardDiscount = getStorage['giftcard'].giftCard;
        var discountName = getStorage['discount'].discountName;
        var cartid = getStorage['giftcard'].cartid;
        if (currentCartId == getStorage['giftcard'].cartid) {
          console.log("newDiscount++4");
          var discountcode = await CreateNewDiscount(discountAmount, giftCardAmount, cartid, giftCardDiscount, discountName);
          console.log("newDiscount++7", discountcode);
        }


      }



    } else if (Object.keys(getStorage).length == 1) {
      if (jQuery.inArray("discount", keysarray) !== -1) {
        if (currentCartId == getStorage['discount'].cartid) {
          console.log('ajax ready');
          var resonse = await singleDiscount(getStorage['discount'].cartid);
          console.log('newDiscount++4');
          var discountcode = getStorage['discount'].discountName;
        }


      } else if (jQuery.inArray("giftcard", keysarray) !== -1) {
        if (currentCartId == getStorage['giftcard'].cartid) {
          console.log('ajax ready');
          var resonse = await singleDiscount(getStorage['giftcard'].cartid);
          console.log('newDiscount++4.2');
          var discountcode = getStorage['giftcard'].giftCard;
        }

      }
    }
  }

  jQuery(".cardnumber-response").html('');

  jQuery('[data-trekkie-id="apply_discount_button"]').removeAttr("disabled");
  jQuery('button.field__input-btn.btn').removeClass("btn--disabled");
  jQuery("input#checkout_reduction_code").parent().parent().find('button').addClass('btngiftsubmit');
  //jQuery("input#checkout_reduction_code").val(code);
  var theUrl = '/checkout?discount=';
  var toRedirect = await theUrl + discountcode;
  console.log(toRedirect);
  window.location.href = toRedirect;
}